import { Injectable } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";
import { StateService } from "./state.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DatadogRumService {
  constructor(private stateService: StateService) {
    if (environment.production) {
      datadogRum.init({
        applicationId: "39945028-6c9e-44b8-8e73-777ec7d369cc",
        clientToken: "pub3272d2f4294e705268be21311b2daae2",
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: "datadoghq.com",
        service: "aipho",
        env: "prod",
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: "mask-user-input",
      });

      datadogRum.startSessionReplayRecording();
    }
  }

  // Helper method the setuser data to datalog
  setUser() {
    // Retrieve user data from localStorage
    const storedUser = localStorage.getItem("user-name");
    if (storedUser) {
      const user = JSON.parse(storedUser);

      // Set user details in Datadog RUM
      datadogRum.setUser({
        id: user.id,
        name: user.first_name,
        email: user.email,
        role: user.role,
      });
    }
  }
}
